
import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
    name: 'ToggleListContent',
    setup() {
        const toggle = ref(false);

        return {
            toggle,
        };
    },
});
